module.exports = __webpack_public_path__ + "static/media/kaju_burfi.29245b0e.jpg";